import {HttpStatus} from '../../../http/status.js';

export type OAuth2Error = {
    readonly errorCode: string
    readonly description?: string
    readonly uri?: string
}

export type BearerTokenError = OAuth2Error & {
    readonly httpStatus: HttpStatus
    readonly scope?: string
}

export const BearerTokenErrorCodes = {
    invalid_request: 'invalid_request',
    invalid_token: 'invalid_token',
    insufficient_scope: 'insufficient_scope',
}

const DEFAULT_URI = "https://tools.ietf.org/html/rfc6750#section-3.1";

export function invalidToken(message: string): BearerTokenError {
    return {
        errorCode: BearerTokenErrorCodes.invalid_token,
        httpStatus: HttpStatus.UNAUTHORIZED,
        description: message,
        uri: DEFAULT_URI
    };
}

export function invalidRequest(message: string): BearerTokenError {
    return {
        errorCode: BearerTokenErrorCodes.invalid_request,
        httpStatus: HttpStatus.BAD_REQUEST,
        description: message,
        uri: DEFAULT_URI
    };
}

export function insufficientScope(message: string, scope?: string): BearerTokenError {
    return {
        errorCode: BearerTokenErrorCodes.insufficient_scope,
        httpStatus: HttpStatus.FORBIDDEN,
        description: message,
        uri: DEFAULT_URI,
        scope
    };
}
